import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import useTranslate from "../../hooks/useTranslate";
import { colorRed } from "../../constants/colors";
import DraggablePaperComponent from "../../components/MUI/DraggablePaperComponent/DraggablePaperComponent";
import { IAlertDialogProps } from "./AlertDialog.props";

const AlertDialog = ({
	showAlertDialog,
	setShowAlertDialog,
	submitHandler,
	closeHandler,
	title,
	description,
	name,
	name2,
	isDisabled = false,
}: IAlertDialogProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	// закрыть диалоговое окно
	const closeAlertDialog = (): void => {
		setShowAlertDialog && setShowAlertDialog(false);
	};

	// обработчик нажатия клавиши
	const keyDownHandler = (e: React.KeyboardEvent<HTMLDivElement>): void => {
		e.preventDefault();
		if (e.code === "Enter") handleSubmit();
	};

	const handleSubmit = (): void => {
		submitHandler();
		closeHandler ? closeHandler() : closeAlertDialog();
	};

	return (
		<Dialog
			open={showAlertDialog}
			onClose={isDisabled ? undefined : closeHandler || closeAlertDialog}
			aria-labelledby="title"
			aria-describedby="alert-dialog-description"
			onKeyDown={isDisabled ? undefined : keyDownHandler}
			PaperComponent={DraggablePaperComponent}
			slotProps={{
				backdrop: {
					sx: { backgroundColor: "rgba(0, 0, 0, 0.15)" },
				},
			}}
		>
			<DialogTitle id="title" color={colorRed} sx={{ fontSize: 16, cursor: "move" }}>
				{translate(title)} {name && `"${name}"`} {name2 && `${translate("dialog_onTitle")} "${name2}"`}
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: 2 }}>
				<DialogContentText id="alert-dialog-description" sx={{ fontSize: 13 }}>
					{translate(description)}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ paddingTop: 0 }}>
				<Button onClick={closeHandler || closeAlertDialog} disabled={isDisabled} sx={{ fontSize: 11 }}>
					{translate("button_no")}
				</Button>
				<Button onClick={handleSubmit} disabled={isDisabled} sx={{ color: colorRed, fontSize: 11 }}>
					{translate("button_yes")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default AlertDialog;
